import { Alert, AlertTitle, CircularProgress } from "@mui/material";

import { RobotoDomainException } from "@/shared/http";

import styles from "./FileList.module.css";

/**
 * Loading fallback for FileList Suspense boundary
 */
export function FileListLoading() {
  return (
    <div className={styles.loadingContainer}>
      <CircularProgress size={32} />
    </div>
  );
}

/**
 * Error fallback for FileList Error Boundary
 */
export function FileListError({ error }: { error: Error }) {
  function getErrorMessage(error: Error) {
    if (error instanceof RobotoDomainException && error.isClientError()) {
      return error.message;
    }
    return "Something went wrong. Please try closing and reopening the file picker.";
  }

  return (
    <div className={styles.errorContainer}>
      <Alert severity="error">
        <AlertTitle>Failed to load files</AlertTitle>
        {getErrorMessage(error)}
      </Alert>
    </div>
  );
}
